module.exports = __webpack_public_path__ + "assets/img/WA.8c9e94b6.png";